import { render, staticRenderFns } from "./EmailFilesPageGrid.vue?vue&type=template&id=0a5f8bfa&"
import script from "./EmailFilesPageGrid.vue?vue&type=script&lang=js&"
export * from "./EmailFilesPageGrid.vue?vue&type=script&lang=js&"
import style0 from "./EmailFilesPageGrid.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports